export default [
  { label: 'All statuses', value: '' },
  { label: 'Online', value: 'online' },
  { label: 'Alert', value: 'alert' },
  { label: 'Offline', value: 'offline' },
]
